import { CSSProperties } from 'react';

export interface IYoutubeEmbed {
  embedId: string;
  style?: CSSProperties;
  className?: string;
}

/**
 * Simple YouTube iframe that keeps 16:9 using the native CSS `aspect-ratio`
 * property — no Tailwind plugin required.
 */
const YoutubeEmbed = ({
  embedId,
  style = {},
  className = '',
}: IYoutubeEmbed) => (
  <iframe
    className={className}
    style={{
      width: '100%',
      aspectRatio: '16 / 9', // keeps the frame proportional
      border: 0,
      ...style,
    }}
    src={`https://www.youtube.com/embed/${embedId}?controls=0`}
    title="Getting-Started video"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowFullScreen
  />
);

export default YoutubeEmbed;
